import React, { useState } from 'react';
import '../fonts.css';
import { stackClientApp } from '../stackClient';

const LoginForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    errorMessage: '',
  });

  const handleInputChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleOAuthSignIn = async (provider) => {
    try {
      await stackClientApp.signInWithOAuth(provider);
      // This will redirect away to Stack, then back to your app.
    } catch (err) {
      console.error(`OAuth sign-in error with ${provider}:`, err);
      setFormData((prev) => ({
        ...prev,
        error: 'OAuth sign-in failed. Please try again.',
        // or errorMessage for LoginForm
      }));
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const { email, password } = formData;

    try {
      const result = await stackClientApp.signInWithCredential({
        email,
        password,
      });

      if (result.status === 'error') {
        console.error('Sign in error:', result.message);
        setFormData((prev) => ({
          ...prev,
          errorMessage:
            result.message || 'Invalid credentials. Please try again.',
        }));
        return;
      }

      const user = await stackClientApp.getUser();
      const authJson = await user.getAuthJson();
      const accessToken = authJson.accessToken;

      // Store what your app needs
      localStorage.setItem('name', user.displayName || '');
      localStorage.setItem('user_email', user.primaryEmail || email);
      localStorage.setItem('stack_user_id', user.id);
      localStorage.setItem('stack_access_token', accessToken);

      console.log('Login successful with Neon Auth');

      window.location.href = '/frontpage';
    } catch (err) {
      console.error('Error during login:', err);
      setFormData((prev) => ({
        ...prev,
        errorMessage: 'Internal Server Error',
      }));
    }
  };

  // ... keep your JSX, just use the updated handleFormSubmit + handleInputChange
  return (
    <div className="min-h-screen flex items-center justify-center bg-headergreen">
      <div
        className="max-w-md w-full p-6 rounded-lg shadow-lg"
        style={{ backgroundColor: '#05664f' }}
      >
        <div className="flex justify-center">
          <img src="/logo.png" alt="logo" />
        </div>
        <h1
          className="text-5xl font-bold text-white text-center mb-6"
          style={{ fontFamily: 'Inter', textTransform: 'uppercase' }}
        >
          LOGIN
        </h1>
        <div className="flex justify-center">
          {formData.errorMessage && (
            <div className="text-red-500 text-sm mb-4 text-center">
              {formData.errorMessage}
            </div>
          )}
        </div>
        <form onSubmit={handleFormSubmit} className="space-y-4">
          {/* Email */}
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-white"
            >
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              style={{ color: '#0d2329' }}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-d1ff5d focus:border-d1ff5d sm:text-sm"
              required
            />
          </div>

          {/* Password */}
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-white"
            >
              Password
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              style={{ color: '#0d2329' }}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-d1ff5d focus:border-d1ff5d sm:text-sm"
              required
            />
          </div>

          {/* Login button */}
          <div className="flex justify-center">
            <button
              type="submit"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-d1ff5d"
              style={{ backgroundColor: '#000000' }}
            >
              LOGIN
            </button>
          </div>

          {/* --- OAuth section --- */}
          <div className="flex items-center my-4">
            <div className="flex-grow h-px bg-gray-300" />
            <span className="px-2 text-sm text-white">OR</span>
            <div className="flex-grow h-px bg-gray-300" />
          </div>

          <div className="space-y-2">
            {/* Google Button */}
            <button
              type="button"
              onClick={() => handleOAuthSignIn('google')}
              className="w-full flex items-center justify-center gap-3 px-4 py-2 border border-gray-300 rounded-md bg-white text-gray-800 font-medium hover:bg-gray-100 transition"
            >
              <svg width="18" height="18" viewBox="0 0 48 48">
                <path
                  fill="#EA4335"
                  d="M24 9.5c3.54 0 6.71 1.22 9.21 3.61l6.89-6.89C35.3 2.38 29.91 0 24 0 14.6 0 6.51 5.16 2.53 12.64l7.96 6.19C12.54 13.79 17.8 9.5 24 9.5z"
                />
                <path
                  fill="#4285F4"
                  d="M46.1 24.55c0-1.57-.14-3.08-.39-4.55H24v9.02h12.46c-.54 2.9-2.18 5.37-4.64 7.02l7.24 5.61c4.24-3.9 7.04-9.64 7.04-16.1z"
                />
                <path
                  fill="#FBBC05"
                  d="M10.49 28.83A14.5 14.5 0 0 1 9.5 24c0-1.67.29-3.28.81-4.83l-7.96-6.19C.83 15.66 0 19.73 0 24s.83 8.34 2.34 11.99l8.15-6.16z"
                />
                <path
                  fill="#34A853"
                  d="M24 48c6.48 0 11.92-2.12 15.89-5.73l-7.24-5.61C30.61 38.41 27.5 39.5 24 39.5c-6.2 0-11.46-4.29-13.51-10.13l-8.15 6.16C6.51 42.84 14.6 48 24 48z"
                />
              </svg>
              Continue with Google
            </button>

            {/* GitHub Button */}
            <button
              type="button"
              onClick={() => handleOAuthSignIn('github')}
              className="w-full flex items-center justify-center gap-3 px-4 py-2 rounded-md bg-[#24292F] text-white font-medium hover:bg-black transition"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
                <path d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.438 9.8 8.205 11.387.6.113.82-.263.82-.583 0-.287-.01-1.244-.015-2.255-3.338.726-4.042-1.61-4.042-1.61-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.73.083-.73 1.205.085 1.84 1.237 1.84 1.237 1.07 1.834 2.807 1.304 3.492.997.108-.775.42-1.305.763-1.605-2.665-.304-5.466-1.332-5.466-5.93 0-1.31.47-2.38 1.237-3.22-.124-.303-.536-1.527.118-3.183 0 0 1.008-.322 3.3 1.23a11.48 11.48 0 0 1 3-.404c1.02.005 2.047.138 3 .404 2.29-1.552 3.297-1.23 3.297-1.23.656 1.656.244 2.88.12 3.183A4.6 4.6 0 0 1 20 9.8c0 4.61-2.807 5.624-5.48 5.92.43.372.814 1.102.814 2.222 0 1.605-.015 2.898-.015 3.293 0 .324.216.702.825.582C20.565 21.796 24 17.297 24 12 24 5.37 18.63 0 12 0z" />
              </svg>
              Continue with GitHub
            </button>
          </div>
        </form>

        <div className="text-center">
          <p className="text-sm text-white">
            Don't have an account?{' '}
            <a href="/" className="text-white">
              Register
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
